import { IconButton, Text } from '@components'
import type { MessageReaction } from '@here/api'
import { useService } from 'solid-services'
import { userId } from '@state'
import { For, Show } from 'solid-js'
import { css } from 'styled-system/css'
import { useUpsert } from '../../state'
import { Box, Flex } from 'styled-system/jsx'

type Reaction = Pick<MessageReaction, 'emoji' | 'created_by'>

interface ReactionsProps {
	reactions?: Reaction[]
	messageId: string
}

export default function (props: ReactionsProps) {
	const { setUpsertMessageReaction } = useService(useUpsert)()

	const upsertReaction = (emoji: string) =>
		setUpsertMessageReaction({
			emoji,
			message_id: props.messageId,
			created_by: userId()!,
		})

	const reactionsDictionary = () => {
		const reactionMap: Record<string, Reaction & { count: number }> = {}

		for (const reaction of props.reactions || []) {
			if (reactionMap[reaction.emoji]) {
				reactionMap[reaction.emoji].count++
			} else {
				reactionMap[reaction.emoji] = {
					emoji: reaction.emoji,
					count: 1,
					created_by: reaction.created_by,
				}
			}
		}

		return Object.values(reactionMap)
	}

	return (
		<>
			<Show when={props.reactions?.length}>
				<Box height={4} />
			</Show>
			<Flex
				gap={1}
				position="absolute"
				bottom="0"
			>
				<Show when={props.reactions?.length}>
					<For each={reactionsDictionary()}>
						{(reaction) => (
							<IconButton
								class={css({
									borderRadius: '50%',
									height: 5,
									minWidth: 5,
									_hover: {
										'& p': {
											opacity: 0,
										},
									},
								})}
								position="relative"
								size="xs"
								// isMine: reaction.created_by === userId(),
								// variant={reaction.isMine ? 'outline' : 'ghost'}
								variant={'ghost'}
								type="button"
								onClick={() => upsertReaction(reaction.emoji)}
							>
								<Box fontSize="13px">{reaction.emoji}</Box>
								<Text
									transition="opacity 0.3s ease"
									position="absolute"
									top={-0.5}
									right={-0.5}
									fontSize="10px"
								>
									{reaction.count < 0 ? '' : reaction.count}
								</Text>
							</IconButton>
						)}
					</For>
				</Show>
			</Flex>
		</>
	)
}
